<template>
  <div>
    <b-modal
      ref="createDivision"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h3
        class="modal-title"
        style="color: #9A9A9A !important">
        CREATE UNIT
      </h3>
      <div>
        <j-division-form
          ref="divisionForm"
          mode="create"
          @data="getData"/>
      </div>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn blue m__r--5"
              @click="saveCreateDivision">
              Create
            </b-button>
            <b-button
              class="btn gray"
              @click="closePage">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import jDivisionForm from '@/views/division/jDivisionForm';
import { mapActions } from 'vuex';

export default {
  components: {
    jDivisionForm,
  },
  data() {
    return {
      division_data: null,
      title: {
        main_title: 'CREATE UNIT',
      },
    };
  },
  computed: {
    generateData() {
      const genData = {
        name: this.division_data.name ? this.division_data.name : '',
        code: this.division_data.code ? this.division_data.code : '',
        head_organigram_id: this.division_data.head_of_division ?
          this.division_data.head_of_division.id : 0,
        root_division_id: 0,
        description: this.division_data.description ? this.division_data.description : '',
      };
      return genData;
    },
  },
  mounted() {
    this.$refs.createDivision.show();
  },
  methods: {
    ...mapActions('jStoreDivisionFlow', ['createDivision']),

    getData(data) {
      this.division_data = data;
    },
    saveCreateDivision() {
      this.$refs.divisionForm.save();
      if (this.division_data !== null) {
        this.createDivision(this.generateData);
        this.closePage();
      }
    },
    closePage() {
      this.$emit('closemodal');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/division/jDivisionCreate.vue